<template>
    <span v-if="text !== null">
        <template v-if="text.length > length && !showFullText">
            <span v-text="shortenedText"></span>
            <a href="#"
               class="btn--sm btn--colored__blue mx-2 py-1"
               @click.prevent="toggle">
                show more
            </a>
        </template>
        <template v-if="showFullText || text.length < length">
            <span v-text="text"></span>
            <a href="#"
               class="btn--sm btn--colored__blue mx-2 py-1"
               @click.prevent="toggle" v-if="text.length > length">
                show less
            </a>
        </template>
    </span>
</template>

<script>
    export default {
        props: ['text'],

        data() {
            return {
                showFullText: false,
                length: 500,
            }
        },

        computed: {
            shortenedText() {
                return this.text.slice(0, this.length);
            }
        },

        methods: {
            toggle() {
                this.showFullText = !this.showFullText
            }
        }
    }
</script>